module.exports = __webpack_public_path__ + "img/2.b83144b1.png";